import { render, staticRenderFns } from "./PendingHotels.vue?vue&type=template&id=b27ea6a0&scoped=true"
import script from "./PendingHotels.vue?vue&type=script&lang=js"
export * from "./PendingHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ea6a0",
  null
  
)

export default component.exports